import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fc-label',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ` <ng-content></ng-content> `,
})
export class LabelComponent {}
